<template><div class="home">

<v-layout row justify-center class="mx-2 my-5">
	<v-flex xs12 sm8 md6 px-2>
		<component :is="FullSetOfRules || $g.NotTranslated"/>
	</v-flex>
</v-layout>

</div></template>

<script>

import i18n from '@/i18n'

export default {
	components: {},
	data: function() {
		return {

		}
	},
	methods: {

	},
	created: function () {

	},
	computed: {
		FullSetOfRules() {
			return i18n.choose[this.$store.state.language].components.FullSetOfRules || i18n.choose['en'].components.FullSetOfRules;
		}
	}
}
</script>

<style>

a {
	text-decoration: none;
}

</style>